import { LORA_GENERATION_TYPE } from "../../../Board/constants.ts";
import {
  getModelDefaultGenerationParams,
  updateModelGenerationParams,
} from "./baseSelectedModelsUtils.ts";
import { selectedModelsStorageFactory } from "./selectedModelsStorageFactory.ts";

export const generativeFillSelectedModelsStorage = selectedModelsStorageFactory(
  "board-generative-fill-selected-models-generation-params",
  2,
  [LORA_GENERATION_TYPE],
  getModelDefaultGenerationParams,
  updateModelGenerationParams,
);
